import { render, staticRenderFns } from "./MassifWork.vue?vue&type=template&id=19022386&scoped=true"
import script from "./MassifWork.vue?vue&type=script&lang=js"
export * from "./MassifWork.vue?vue&type=script&lang=js"
import style0 from "./MassifWork.vue?vue&type=style&index=0&id=19022386&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19022386",
  null
  
)

export default component.exports